import axios from 'axios';

// Create an instance of axios with default config
const instance = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Добавляем интерцептор запросов для добавления credentials и предотвращения кэширования
instance.interceptors.request.use(
  (config) => {
    // Ensure credentials are included with every request
    config.withCredentials = true;
    
    // Add cache busting for GET requests
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      };
    }
    
    // Debug logging
    console.log(`Making ${config.method.toUpperCase()} request to ${config.url} with credentials`);
    
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Intercept all responses to handle errors globally
instance.interceptors.response.use(
  (response) => {
    // Log successful responses for debugging
    console.log(`Response from ${response.config.url}:`, response.status);
    return response;
  },
  (error) => {
    // Enhanced error logging with more details
    console.error('API Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.response?.data?.error || error.message
    });
    
    // Store error details in sessionStorage for the error page to access
    if (error.response) {
      const errorData = {
        status: error.response.status,
        message: error.response.data?.error || error.message,
        timestamp: new Date().toISOString()
      };
      sessionStorage.setItem('lastApiError', JSON.stringify(errorData));

      // Don't redirect here, let the component handle the navigation
      // This ensures proper React router navigation instead of full page refresh
    } else if (error.request) {
      // The request was made but no response was received
      sessionStorage.setItem('lastApiError', JSON.stringify({
        status: 'network-error',
        message: 'Network error - unable to connect to the server',
        timestamp: new Date().toISOString()
      }));
    } else {
      // Something happened in setting up the request that triggered an Error
      sessionStorage.setItem('lastApiError', JSON.stringify({
        status: 'config-error',
        message: error.message,
        timestamp: new Date().toISOString()
      }));
    }
    
    // Continue with the error for local handling
    return Promise.reject(error);
  }
);

// Add a property to hold the last error
instance.lastError = null;

export default instance; 